import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';

import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { AuthModule } from '@app/core/auth';

// Scroll strategy estable para mat-select en Home
export function matSelectScrollStrategyFactory(overlay: Overlay) {
  return () => overlay.scrollStrategies.reposition();
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CoreModule,
    SharedModule,
    HomeRoutingModule,
    AuthModule
  ],
  declarations: [HomeComponent],
  providers: [
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      deps: [Overlay],
      useFactory: matSelectScrollStrategyFactory
    }
  ]
})
export class HomeModule {}
